<script setup> 
    import { computed } from 'vue';
    import AchievementTable from '@/components/result/ai-literacy-2026/AchievementTable.vue'; 
    import LevelRatio from '@/components/result/ai-literacy-2026/LevelRatio.vue';
    import { achievementRanges, resolveAchievementLevel } from '@/components/result/ai-literacy-2026/data/reportLogic';

    const props = defineProps({
        teacherData: Object
    });

    const userRole = 'teacher';
    const schulType = computed(() => props.teacherData?.schul_type || 'E');

    const achievementTableProps = computed(() => ({
        levelYear: parseInt(props.teacherData?.grade_code) || 1,
        userRole: 'teacher',
        studentLevel: 4,
        schulType: schulType.value
    }));

    // 성취수준별 점수 구간 (기준 점수가 없는 학교급은 구간 텍스트 생략)
    const rangeText = (level) => {
        const ranges = achievementRanges(schulType.value);
        const r = ranges?.find(x => x.level === level);
        return r ? `${r.min}~${r.max}` : '';
    };

    // teacherData.list 기반 수준별 학생 명단 (번호순)
    const rateTableData = computed(() => {
        const students = props.teacherData?.list || [];
        const levelGroups = { 4: [], 3: [], 2: [], 1: [] };
        students.forEach(student => {
            const level = resolveAchievementLevel(schulType.value, student.achievement_level, student.total_score);
            if (levelGroups[level]) levelGroups[level].push(student);
        });
        Object.keys(levelGroups).forEach(level => {
            levelGroups[level].sort((a, b) => (parseInt(a.school_num) || 0) - (parseInt(b.school_num) || 0));
        });
        return [4, 3, 2, 1].map(level => ({
            level: String(level),
            scoreRange: rangeText(level),
            students: levelGroups[level].map(s => s.name).join(', ')
        }));
    });

    // 3수준 이상 비율 / 1수준 비율
    const achievementMessage = computed(() => {
        if (!props.teacherData) return { highLevelRate: '0', lowLevelRate: '0' };
        const l1 = props.teacherData.achievement1_level_cnt || 0;
        const l2 = props.teacherData.achievement2_level_cnt || 0;
        const l3 = props.teacherData.achievement3_level_cnt || 0;
        const l4 = props.teacherData.achievement4_level_cnt || 0;
        const total = l1 + l2 + l3 + l4;
        if (total === 0) return { highLevelRate: '0', lowLevelRate: '0' };
        return {
            highLevelRate: (((l3 + l4) / total) * 100).toFixed(1),
            lowLevelRate: ((l1 / total) * 100).toFixed(1)
        };
    });
</script>
<template>
    <div class="report-inner">   
        <div class="card-wrap">
            <AchievementTable 
                :userRole="userRole" 
                :levelYear="achievementTableProps.levelYear"
                :studentLevel="achievementTableProps.studentLevel"
                :schulType="achievementTableProps.schulType"
            />
            <LevelRatio 
                :table-data="rateTableData" 
                :achievement-message="achievementMessage"
            />             
        </div>
    </div>
</template>
